module.exports = __webpack_public_path__ + "media/images/front/icon_movie_free-d03a2f5f8e4ad262bc470bdb055593de.png";